import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useState, useEffect } from "react";
export var useDebouncedValue = function(value, delay) {
    var _useState = _sliced_to_array(useState(value), 2), debouncedValue = _useState[0], setDebouncedValue = _useState[1];
    useEffect(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
